/** Portal dashboard chrome accents — matches each site's primary brand color. */
export const ACCENT_STYLES = {
    orange: {
        tabActive: 'border-orange-500 text-orange-700',
        tabInactive: 'border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-800',
        tabFocus: 'focus-visible:ring-orange-400',
        periodActive: 'border-orange-400 bg-orange-50 text-orange-800',
        periodInactive: 'border-gray-200 bg-white text-gray-600 hover:bg-gray-50',
        periodApply: 'bg-orange-500 hover:bg-orange-600',
        periodFocus: 'focus-visible:ring-orange-400',
        segmentContainer: 'border-orange-200/80 bg-orange-50/40',
        segmentActive: 'bg-orange-100 text-orange-800',
        segmentInactive: 'text-gray-600 hover:bg-orange-50 hover:text-gray-900',
        rangeRefresh: 'border-orange-200 text-orange-800 hover:bg-orange-50',
    },
    emerald: {
        tabActive: 'border-emerald-500 text-emerald-700',
        tabInactive: 'border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-800',
        tabFocus: 'focus-visible:ring-emerald-400',
        periodActive: 'border-emerald-400 bg-emerald-50 text-emerald-800',
        periodInactive: 'border-gray-200 bg-white text-gray-600 hover:bg-gray-50',
        periodApply: 'bg-emerald-600 hover:bg-emerald-700',
        periodFocus: 'focus-visible:ring-emerald-400',
        segmentContainer: 'border-emerald-200/80 bg-emerald-50/40',
        segmentActive: 'bg-emerald-100 text-emerald-800',
        segmentInactive: 'text-gray-600 hover:bg-emerald-50 hover:text-gray-900',
        rangeRefresh: 'border-emerald-200 text-emerald-800 hover:bg-emerald-50',
    },
    blue: {
        tabActive: 'border-blue-500 text-blue-700',
        tabInactive: 'border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-800',
        tabFocus: 'focus-visible:ring-blue-400',
        periodActive: 'border-blue-400 bg-blue-50 text-blue-800',
        periodInactive: 'border-gray-200 bg-white text-gray-600 hover:bg-gray-50',
        periodApply: 'bg-blue-600 hover:bg-blue-700',
        periodFocus: 'focus-visible:ring-blue-400',
        segmentContainer: 'border-blue-200/80 bg-blue-50/40',
        segmentActive: 'bg-blue-100 text-blue-800',
        segmentInactive: 'text-gray-600 hover:bg-blue-50 hover:text-gray-900',
        rangeRefresh: 'border-blue-200 text-blue-800 hover:bg-blue-50',
    },
};
export function accentStyle(accent = 'orange') {
    return ACCENT_STYLES[accent];
}
